import { Navigate } from "react-router-dom";
import { Room } from "../pages";
import NotFound from "../pages/NotFound";
import RoomValidator from "../components/RoomValidate";
import RoomFull from "../pages/RoomFull";
import VideoChatLobby from "../pages/VideoChatLobby";
import DeviceCheck from "../pages/DeviceCheck";
import { routes } from "./AllRoutes";
import ValidateUser from "../auth/ValidateUser";
// import ValidTokenPage from "../auth/ValidTokenPage";
// import Login from "../auth/Login";


// export const LoginRoute = [
//   {
//     path: "*",
//     element: <ValidateUser />,
//   },
//   {
//     path: "/:token",
//     element: <Login />,
//   },
//   // {
//   //   path: "*",
//   //   element: <Navigate to="/" />,
//   // },
// ];


export const LobbyRoutes = [
  {
    path: "*",
    element: <ValidateUser />,
  },
  {
    path: "/login",
    element: <Navigate to={routes.lobby} />,
  },
  {
    path: routes.lobby,
    element: <VideoChatLobby />,
  },
  // {
  //   path: routes.home,
  //   element: <VideoChatLobby />,
  // },
  {
    path: routes.deviceCheck,
    element: <DeviceCheck />,
  },
  {
    path: routes.room,
    element: (
      <RoomValidator>
        <Room />
      </RoomValidator>
    ),
  },
  {
    path: routes.invalid,
    element: <RoomFull />,
  },
  {
    path: routes.notFound,
    element: <NotFound />,
  },
];
